import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, DatePicker, Radio, Select, Checkbox, Upload, Button, Row, Col, Spin, notification, CheckboxProps } from 'antd';
import type { UploadProps } from 'antd/es/upload';
import { LinkOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';

import individualForm from "../../media/Individual Share form.pdf"
import Signature from "../../components/Signature";

import config from "../../config.json";
import axios from "axios";
import Success from "../../components/Success";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';


const Individual = () => {
    const [physicalForm, setPhysicalForm] = useState(false);
    
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [submitted, setSubmit] = useState(false);
    const [kitta, setKitta] = useState<number>(1000);
    const [rate, setRate] = useState<number>(1);
    const [form] = Form.useForm();
    const [signatureCleared, setSignatureCleared] = useState(false);
    const navigate = useNavigate();
    const goBack = () => {
      navigate(-1);
    }


    const onFinish = async (values: any) => {
        console.log(localStorage.getItem("signature"))
        if (!localStorage.getItem("signature")) {
            alert("Signature is not saved. Save signature and submit.");
            return; // Prevent form submission
          }
        var formData = {
            kitta: values.kitta,
            rate: values.rate,
            amount: values.amount,
            shareholder_firstname: values.firstName,
            shareholder_middlename: values.middleName,
            shareholder_lastname: values.lastName,
            shareholderdob: values.dob,
            gender: values.gender,
            citizenshipno: values.citizenshipno,
            anchal_permanent: values.pradeshPermanent,
            district_permanent: values.districtPermanent,
            municipality_permanent: values.municipality,
            ward_no_permanent: values.wardNoPermanent,
            tol_permanent: values.tolePermanent,
            houseno_permanent: values.housenoPermanent,

            pradesh_temporary: values.pradeshTemporary,
            district_temporary: values.districtTemporary,
            municipality_temporary: values.municipalityTemporary,
            ward_no_temporary: values.wardNoTemporary,
            tol_temporary: values.tolTemporary,
            houseno_temporary: values.housenoTemporary,

            shareholder_phoneno: values.phonenumber,
            shareholder_email: values.email,

            shareholder_spouse: values.spouseName,
            shareholder_fathername: values.fathersName,
            shareholder_grandfathername: values.grandfatherName,

            nominee_name : values.nomineeName,
            nominee_relationship: values.relationtonominee,
            nominee_gender : values.genderNominee,
            nominee_pradesh : values.pradeshNominee,
            nominee_district: values.districtNominee,
            nominee_municipality: values.municipalityNominee,
            nominee_wardno: values.wardNoNominee,
            nominee_tol : values.tolNominee,
            nominee_houseno: values.housenoNominee,
            nominee_phone: values.phoneNominee,
            nominee_email : values.emailNominee,
            nominee_citizenship : values.citizenshipnoNominee,
           

            deposit_type: values.paymentDepositOption,

            document_citizenshipfilecopy: values.citizenshipCopy.file.originFileObj,
            document_self_portrait: values.selfPhoto.file.originFileObj,
            payslip : values.payslip.file.originFileObj,

            signature: localStorage.getItem("signature")

        }
        console.log(formData);

        setLoading(true)
       // const csrfToken = localStorage.getItem("csrfToken");

        const URL = (config.env === "prod" ? config.prodURL : config.env === "test" ? config.testURL : config.localURL) + "individualshare";
        console.log("URL: ", URL)
        try {
            const response = await axios.post(URL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setSuccess(true);
            setSubmit(true);
            setLoading(false)
            console.log("Form submitted successfully:: ", response.data);
        } catch (error) {
            notification["error"]({
                message: "Submit Error",
                description: "Something went wrong. Please try again later.",
                placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
            });
            console.error('Error uploading file:', error);
            setLoading(false)
        }
        
    }


    const onFinishPhysicalForm = async (values: any) => {
        var physicalForm = {
            firstName: values.firstName,
            middleName: values.middleName,
            lastName: values.lastName,
            depositType: values.depositType,
            filledForm: values.individualsharefilledform.file.originFileObj,
            payslip: values.payslip.file.originFileObj
        }

        console.log(physicalForm)

        setLoading(true);

        const URL = (config.env === "prod" ? config.prodURL : config.env === "test" ? config.testURL : config.localURL) + "individualsharephysicalform";
        console.log("URL: ", URL)
        try {
            const response = await axios.post(URL, physicalForm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setSuccess(true);
            setSubmit(true);
            // console.log("Form submitted successfully:: ", response.data);
        } catch (error) {
            notification["error"]({
                message: "Submit Error",
                description: "Something went wrong. Please try again later.",
                placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
            });
            console.error('Error uploading file:', error);
        }
        setLoading(false)
    }


    const amount = kitta * rate;

    const calculateAmount = () => {
        const kitta = form.getFieldValue('kitta');
        const rate = form.getFieldValue('rate');
        if (kitta && rate) {
            form.setFieldsValue({ amount: kitta * rate });
        }
    };

    const sameAsPermanentAddress: CheckboxProps['onChange'] = (e) => {
        if (e.target.checked) {
            form.setFieldsValue({
                pradeshTemporary: form.getFieldValue("pradeshPermanent"),
                districtTemporary: form.getFieldValue("districtPermanent"),
                municipalityTemporary: form.getFieldValue("municipality"),
                wardNoTemporary: form.getFieldValue("wardNoPermanent"),
                tolTemporary: form.getFieldValue("tolePermanent"),
                housenoTemporary: form.getFieldValue("housenoPermanent"),

            });
        }else{
            form.setFieldsValue({
                pradeshTemporary: "",
                districtTemporary: "",
                municipalityTemporary: "Metropolitan",
                wardNoTemporary: "",
                tolTemporary: "",
                housenoTemporary: "",

            });
        }


    }

    const handleClearSignature = (cleared : any) => {
        setSignatureCleared(cleared);
      };

    useEffect(() => {
        window.scrollTo(0, 0);
        localStorage.removeItem("signature");
      }, [])


    return (
        <div className="about-container">
            <div className="content-left">
            <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
                <h1>Individual Share</h1>
                <button onClick={(e) => {setPhysicalForm(!physicalForm); setLoading(false); setSubmit(false)}}>{!physicalForm ? "Physical Form" : "Individual Form"}</button>
                <a style={{margin: 10}} href="/#/company"><button  >Company Share</button></a>

                {submitted && success ? (
                  <Success/>
                    
                ):
                (
                    physicalForm ?
                    (
                        <>
                            <div>
                                <a style={{ fontSize: '17px', marginTop: '10px' }} href={individualForm} download >Download Physical Form for Individual Share</a><LinkOutlined />

                            </div>
                            <Form className="form" form={form} onFinish={onFinishPhysicalForm}>
                                <h2>Personal Information</h2>
                                <Row>
                                    <Form.Item style={{ marginRight: '10px' }} label="First Name" rules={[{ required: true, message: 'Please enter first name!' }]} name="firstName">
                                        <Input width={200}></Input>
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Middle Name" name="middleName">
                                        <Input width={200}></Input>
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Last Name" rules={[{ required: true, message: 'Please enter last name' }]} name="lastName">
                                        <Input width={200}></Input>
                                    </Form.Item>
                                </Row>
                                <h2>Payment Information</h2>
                                <Form.Item style={{ marginRight: '10px' }} label="Payment Deposit Option" rules={[{ required: true, message: 'Please select payment deposit type' }]} name="depositType">
                                    <Checkbox.Group>
                                        <Checkbox value="selfDeposit">Self Deposit</Checkbox>
                                        <Checkbox value="bankTransfer">Bank Transfer</Checkbox>
                                        <Checkbox value="check">Cheque</Checkbox>
                                        <Checkbox value="other">Other</Checkbox>
                                    </Checkbox.Group>
                                </Form.Item>

                                <div>
                                    <p><b>Ac Name: </b>Brahma Jyoti Holdings Public Limited</p>

                                    <p><b>Bank: </b>Laxmi Sunrise Bank, Kamalpokhari</p>
                                    <p><b>Ac No: </b>0691563348011026</p>
                                    <p><b>Swift Code: </b>LXBLNPKA</p>
                                </div>

                                <Form.Item style={{ marginRight: '10px' }} label="Individual Share Filled Form" name="individualsharefilledform" rules={[{ required: true, message: 'Please upload filled individual share form!' }]}>
                                    <Upload >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item style={{ marginRight: '10px' }} label="Payslip" name="payslip" rules={[{ required: true, message: 'Please upload payslip!' }]}>
                                    <Upload >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                                <Row >
                                    <Form.Item style={{ marginRight: '10px' }}>
                                        <Button disabled={loading} type="primary" htmlType="submit">
                                            Submit
                                        </Button>
                                    </Form.Item>
                                    {loading && (
                                        <div className="loading-overlay">
                                            <Spin size="large" /> {/* Ant Design spinner */}
                                        </div>
                                    )}
                                </Row>
                            </Form>
                        </>
                    ) :
                    (
                        <>
                            <Form className="form"
                                style={{ background: "#f6fff8" }}
                                form={form}
                                layout="horizontal"
                                onFinish={onFinish}
                                initialValues={{
                                    kitta: 1000,
                                    rate: 1,
                                }}
                            >
                                {/* Share Information Section */}
                                <h2>Share Information</h2>
                                <Row gutter={16}>

                                    <Form.Item style={{ marginRight: '10px' }} label="Kitta" name="kitta" rules={[{ required: true, message: 'Please input kitta!' }]}>
                                        <InputNumber min={1000} onChange={calculateAmount} style={{ width: '100%' }} />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Rate" name="rate" rules={[{ required: true, message: 'Please input rate!' }]}>
                                        <InputNumber min={0} onChange={calculateAmount} style={{ width: '100%' }} />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Amount" name="amount">
                                        <InputNumber value={amount} disabled style={{ width: '100%' }} />
                                    </Form.Item>

                                </Row>
                                {/* Personal Information Section */}
                                <h2>Personal Information</h2>
                                <Row >

                                    <Form.Item style={{ marginRight: '10px' }} label="First Name" name="firstName" rules={[{ required: true, message: 'Please input your first name!' }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Middle Name" name="middleName" rules={[{ required: false, message: 'Please input your first name!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Last Name" name="lastName" rules={[{ required: true, message: 'Please input your last name!' }]}>
                                        <Input />
                                    </Form.Item>

                                    <Form.Item style={{ marginRight: '10px' }} label="Date of Birth" name="dob" rules={[{ required: true, message: 'Please select your date of birth!' }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Gender" name="gender" rules={[{ required: true, message: 'Please select your gender!' }]}>
                                        <Radio.Group
                                            block
                                            options={[{ label: "Male", value: "Male" }, { label: "Female", value: "Female" }]}
                                            defaultValue="Male"
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Citizenship number" name="citizenshipno" rules={[{ required: true, message: 'Please input your citizenship number!' }]}>
                                        <Input />
                                    </Form.Item>

                                </Row>


                                {/* Address Section */}
                                <h2>Permanent Address (According to Citizenship Card)</h2>
                                <Row gutter={16}>

                                    <Form.Item style={{ marginRight: '10px' }} label="Pradesh" name="pradeshPermanent" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="District" name="districtPermanent" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>



                                    <Form.Item style={{ marginRight: '10px' }} label="Municipality" name="municipality" rules={[{ required: true, message: 'Please select municipality type!' }]}>
                                        <Radio.Group
                                            block
                                            options={[{ label: "Metropolitan", value: "Metropolitan" }, { label: "Municipality", value: "Municipality" }, { label: "Rural", value: "Rural" }]}
                                            defaultValue="Metropolitan"
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Ward No" name="wardNoPermanent" rules={[{ required: true, message: 'Please input your ward number!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Tole" name="tolePermanent" rules={[{ required: true, message: 'Please input your tol!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="House Number" name="housenoPermanent" rules={[{ required: false, message: 'Please input your house number!' }]}>
                                        <Input />
                                    </Form.Item>


                                </Row>
                                <h2>Temporary Address</h2>
                                <Checkbox style={{ margin: '10px' }} onChange={sameAsPermanentAddress}>Same as permanent address</Checkbox>
                                <Row gutter={16}>

                                    <Form.Item style={{ marginRight: '10px' }} label="Pradesh" name="pradeshTemporary" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="District" name="districtTemporary" rules={[{ required: true, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>



                                    <Form.Item style={{ marginRight: '10px' }} label="Municipality" name="municipalityTemporary" rules={[{ required: true, message: 'Please select municipality type!' }]}>
                                        <Radio.Group
                                            block
                                            options={[{ label: "Metropolitan", value: "Metropolitan" }, { label: "Municipality", value: "Municipality" }, { label: "Rural", value: "Rural" }]}
                                            defaultValue="Metropolitan"
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>



                                    <Form.Item style={{ marginRight: '10px' }} label="Ward No" name="wardNoTemporary" rules={[{ required: true, message: 'Please input your ward number!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Tole" name="tolTemporary" rules={[{ required: true, message: 'Please input your tol!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="House Number" name="housenoTemporary" rules={[{ required: false, message: 'Please input your house number!' }]}>
                                        <Input />
                                    </Form.Item>


                                </Row>
                                <h2>Contact Information</h2>
                                <Row>
                                    <Form.Item style={{ marginRight: '10px' }} label="Phone Number" name="phonenumber" rules={[{ required: true, message: 'Please input your phone number!' }]}>
                                        <Input style={{ width: '140px' }} />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Email" name="email" rules={[{ required: false, message: 'Please input your email!' }]}>
                                        <Input type="email" style={{ width: '268px' }} />
                                    </Form.Item>


                                </Row>



                                <h2>Family Information</h2>
                                <Row>
                                    <Form.Item style={{ marginRight: '10px' }} label="Spouse Name" name="spouseName">
                                        <Input style={{ width: '268px' }} />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Father's Name" name="fathersName">
                                        <Input style={{ width: '268px' }} />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Grandfather Name / Father in Law" name="grandfatherName">
                                        <Input style={{ width: '268px' }} />
                                    </Form.Item>

                                </Row>
                                <h2>Nominee Information</h2>
                                <Row>
                                    <Form.Item style={{ marginRight: '10px' }} label="Nominee name" name="nomineeName" rules={[{ required: false, message: 'Please enter nominee name!' }]} >
                                        <Input style={{ width: '268px' }} />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Relationship to Nominee" name="relationtonominee" rules={[{ required: false, message: 'Please enter nominee name!' }]}>
                                        <Input style={{ width: '268px' }} />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Gender" name="genderNominee" rules={[{ required: false, message: 'Please select your gender!' }]}>
                                        <Radio.Group
                                            block
                                            options={[{ label: "Male", value: "Male" }, { label: "Female", value: "Female" }]}
                                            defaultValue="Male"
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Citizenship number" name="citizenshipnoNominee" rules={[{ required: false, message: 'Please input your citizenship number!' }]}>
                                            <Input />
                                        </Form.Item>
                                </Row>

                                <Row gutter={16}>

                                    <Form.Item style={{ marginRight: '10px' }} label="Pradesh" name="pradeshNominee" rules={[{ required: false, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="District" name="districtNominee" rules={[{ required: false, message: 'Please input your temporary address!' }]}>
                                        <Input />
                                    </Form.Item>



                                    <Form.Item style={{ marginRight: '10px' }} label="Municipality" name="municipalityNominee" rules={[{ required: false, message: 'Please select municipality type!' }]}>
                                        <Radio.Group
                                            block
                                            options={[{ label: "Metropolitan", value: "Metropolitan" }, { label: "Municipality", value: "Municipality" }, { label: "Rural", value: "Rural" }]}
                                            defaultValue="Metropolitan"
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </Form.Item>
                                    <Form.Item style={{ marginRight: '10px' }} label="Ward No" name="wardNoNominee" rules={[{ required: false, message: 'Please input your ward number!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="Tole" name="tolNominee" rules={[{ required: false, message: 'Please input your tol!' }]}>
                                        <Input />
                                    </Form.Item>


                                    <Form.Item style={{ marginRight: '10px' }} label="House Number" name="housenoNominee" rules={[{ required: false, message: 'Please input your house number!' }]}>
                                        <Input />
                                    </Form.Item>

                                    <Form.Item style={{ marginRight: '10px' }} label="Phone Number" name="phoneNominee" rules={[{ required: false, message: 'Please input your phone number!' }]}>
                                        <Input style={{ width: '140px' }} />
                                    </Form.Item>
                                    <Row>

                                        {/* Email */}
                                        <Form.Item style={{ marginRight: '10px' }} label="Email" name="emailNominee" rules={[{ required: false, message: 'Please input your email!' }]}>
                                            <Input type="email" style={{ width: '268px' }} />
                                        </Form.Item>

                                    </Row>
                                </Row>

                                <h2>Payment Information</h2>
                                <Form.Item style={{ marginRight: '10px' }} label="Payment Deposit Option" name="paymentDepositOption" rules={[{ required: true, message: 'Please select deposit option' }]}>
                                    <Checkbox.Group>
                                        <Checkbox value="selfDeposit">Self Deposit</Checkbox>
                                        <Checkbox value="bankTransfer">Bank Transfer</Checkbox>
                                        <Checkbox value="check">Cheque</Checkbox>
                                        <Checkbox value="other">Other</Checkbox>
                                    </Checkbox.Group>
                                </Form.Item>
                                <div>
                                    <p><b>Ac Name: </b>Brahma Jyoti Holdings Public Limited</p>

                                    <p><b>Bank: </b>Laxmi Sunrise Bank, Kamalpokhari</p>
                                    <p><b>Ac No: </b>0691563348011026</p>
                                    <p><b>Swift Code: </b>LXBLNPKA</p>
                                </div>





                                <h2>Documents</h2>
                                <Form.Item style={{ marginRight: '10px' }} label="Photocopy of Citizenship" name="citizenshipCopy" rules={[{ required: true, message: 'Please upload company registration document!' }]}>
                                    <Upload>
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item style={{ marginRight: '10px' }} label="Self Photo" name="selfPhoto" rules={[{ required: true, message: 'Please upload company registration document!' }]}>
                                    <Upload >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item style={{ marginRight: '10px' }} label="Payslip" name="payslip" rules={[{ required: true, message: 'Please upload company payment document!' }]}>
                                    <Upload >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                                {/* Signature Section */}
                                <h2>Signature</h2>
                     
                                    <Signature onClear={handleClearSignature} />
                        


                                {/* Submit Button */}
                                <Row >
                                    <Form.Item style={{ marginRight: '10px' }}>
                                        <Button disabled={loading} type="primary" htmlType="submit">
                                            Submit
                                        </Button>
                                    </Form.Item>
                                    {loading && (
                                        <div className="loading-overlay">
                                            <Spin size="large" /> {/* Ant Design spinner */}
                                        </div>
                                    )}
                                </Row>


                            </Form>

                        </>
                    )
                )
                
              
                }

            </div>
        </div>
    )
}


export default Individual;